import { render, staticRenderFns } from "./BaseSpecialNewEdit.vue?vue&type=template&id=6399f2d0&scoped=true&"
import script from "./BaseSpecialNewEdit.vue?vue&type=script&lang=js&"
export * from "./BaseSpecialNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399f2d0",
  null
  
)

export default component.exports